import{styled as e}from"@mui/joy";import a from"@mui/joy/Card";var r=e(a)(({theme:e})=>({backgroundColor:e.palette.isDarkMode?e.palette.neutral[200]:e.palette.neutral[100]}));export{r as BaseCard};
//# sourceMappingURL=BaseCard.js.map